"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CampaignSubmissionBody = exports.CampaignSubmissionModal = void 0;

var _react = babelHelpers.interopRequireWildcard(require("react"));

var _reactDom = babelHelpers.interopRequireDefault(require("react-dom"));

var _classList = babelHelpers.interopRequireDefault(require("class-list"));

var _base = require("modals/base");

var _promisePolyfill = babelHelpers.interopRequireDefault(require("promise-polyfill"));

var _decorators = require("decorators");

var _fetch = babelHelpers.interopRequireDefault(require("fetch"));

var _S3FileUploadControl = require("components/S3FileUploadControl");

var _userProfile = require("user-profile");

var _noty = require("noty");

var _animationHelper = babelHelpers.interopRequireDefault(require("animation-helper"));

var _text = require("modals/text");

var _SiteLayout = babelHelpers.interopRequireDefault(require("layouts/SiteLayout"));

var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _temp;

var NoOp = function NoOp() {};

var CampaignSubmissionModal =
/*#__PURE__*/
function (_ReactModal) {
  babelHelpers.inherits(CampaignSubmissionModal, _ReactModal);

  function CampaignSubmissionModal(campaign, record) {
    var _this;

    var asModerator = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var asOwner = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
    babelHelpers.classCallCheck(this, CampaignSubmissionModal);
    _this = babelHelpers.possibleConstructorReturn(this, babelHelpers.getPrototypeOf(CampaignSubmissionModal).call(this));
    _this.removeOnHide = true;
    _this.classList = _this.classList.concat('campaign-submission-modal');

    _this.setComponent(_react.default.createElement(CampaignSubmissionBody, {
      campaign: campaign,
      submission: record,
      asModerator: asModerator,
      asOwner: asOwner,
      modal: babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this))
    }));

    return _this;
  }

  return CampaignSubmissionModal;
}(_base.ReactModal);

exports.CampaignSubmissionModal = CampaignSubmissionModal;
var CampaignSubmissionBody = (_class = (_temp =
/*#__PURE__*/
function (_Component) {
  babelHelpers.inherits(CampaignSubmissionBody, _Component);
  babelHelpers.createClass(CampaignSubmissionBody, [{
    key: "getTypeAndId",
    value: function getTypeAndId(src) {
      // YouTube
      var tmp;

      if (tmp = /^https?:\/\/youtu\.be\/([^\/?]+)/.exec(src)) {
        return {
          type: 'youtube',
          id: decodeURIComponent(tmp[1])
        };
      }

      if (tmp = /^https?:\/\/www\.youtube\.com\/watch\?/.exec(src)) {
        tmp = /[\?&]v=([^&]+)/.exec(src);
        if (tmp) return {
          type: 'youtube',
          id: decodeURIComponent(tmp[1])
        };
      }

      if (tmp = /^https?:\/\/www\.youtube\.com\/embed\/([^\/?]+)/.exec(src)) {
        return {
          type: 'youtube',
          id: decodeURIComponent(tmp[1])
        };
      }

      if (tmp = /^https?:\/\/vimeo\.com\/(\d+)/.exec(src)) return {
        type: 'vimeo',
        id: decodeURIComponent(tmp[1])
      };
      return null;
    }
  }]);

  function CampaignSubmissionBody(props) {
    var _this2;

    babelHelpers.classCallCheck(this, CampaignSubmissionBody);
    _this2 = babelHelpers.possibleConstructorReturn(this, babelHelpers.getPrototypeOf(CampaignSubmissionBody).call(this, props));
    _this2.state = {
      submissionComplete: false,
      submitting: false,
      deletingSubmission: false,
      title: "",
      tags: [],
      description: "",
      listImage: null,
      content: null,
      explicitContent: false,
      generation: 1,
      thumbGeneration: 1,
      mediaType: _this2.campaign.mediaType == 'submissionVideo' || _this2.campaign.mediaType == '_all' ? 'submissionLink' : _this2.campaign.mediaType,
      hideFromSite: false,
      videoLink: ""
    };
    babelHelpers.initializerDefineProperty(_this2, "campaign", _descriptor, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this2)));
    babelHelpers.initializerDefineProperty(_this2, "submission", _descriptor2, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this2)));
    babelHelpers.initializerDefineProperty(_this2, "modal", _descriptor3, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this2)));
    babelHelpers.initializerDefineProperty(_this2, "asOwner", _descriptor4, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this2)));
    babelHelpers.initializerDefineProperty(_this2, "asModerator", _descriptor5, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this2)));
    _this2.acceptTypes = {
      image: {
        extensions: ['jpg', 'jpeg', 'png', 'gif'],
        types: ['image/jpeg', 'image/pjpeg', 'image/png', 'image/gif']
      },
      submissionVideo: {
        extensions: ['3gp', 'avi', 'flv', 'm2ts', 'm4v', 'mp4', 'mpg', 'mpeg', 'mts', 'mov', 'wmv'],
        types: ['video/*'],
        label: 'Video',
        uploadLabel: 'Video'
      },
      submissionAudio: {
        extensions: ['wav', 'mp3', 'm4a', 'mp4', 'mpg'],
        types: ['audio/*'],
        label: 'Audio',
        uploadLabel: 'Audio'
      },
      submissionDocument: {
        extensions: ['pdf'],
        types: ['application/pdf'],
        label: 'PDF',
        uploadLabel: 'PDF'
      },
      _any: {
        extensions: ['3gp', 'avi', 'flv', 'm2ts', 'm4v', 'mp4', 'mpg', 'mpeg', 'mts', 'mov', 'wmv', 'wav', 'mp3', 'm4a', 'pdf'],
        types: ['video/*', 'audio/*', 'application/pdf'],
        label: 'File',
        uploadLabel: 'Video, Audio, or PDF'
      }
    };

    if (_this2.submission) {
      _this2.state.title = _this2.submission.title;
      _this2.state.tags = _this2.submission.tags;

      if (_this2.submission.description.editable) {
        var d = document.createElement('div');
        d.innerHTML = _this2.submission.description.markup;
        var e;

        while (e = d.querySelector('p')) {
          while (e.firstChild) {
            e.parentNode.insertBefore(e.firstChild, e);
          }

          e.parentNode.insertBefore(document.createElement('br'), e);
          e.parentNode.insertBefore(document.createElement('br'), e);
          e.parentNode.removeChild(e);
        }

        while (e = d.querySelector('br')) {
          e.parentNode.insertBefore(document.createTextNode("\n"), e);
          e.parentNode.removeChild(e);
        }

        var dt = d.textContent.split("\n").map(function (v) {
          return v.replace(/^\s*/, '').replace(/\s*$/, '');
        });
        dt = dt.reduce(function (acc, value) {
          if (acc.length || value) acc.push(value);
          return acc;
        }, []);

        while (dt[dt.length - 1] == '') {
          dt.pop();
        }

        _this2.state.description = dt.join('\n');
      }

      _this2.state.listImage = _this2.submission.thumbnail;
      _this2.state.explicitContent = _this2.submission.explicit;
      _this2.state.hideFromSite = _this2.submission.hideFromSite;

      if (_this2.submission.videoLink) {
        _this2.state.mediaType = 'submissionLink';
        _this2.state.videoLink = _this2.submission.videoLink;
      } else if (_this2.campaign.mediaType == 'submissionVideo' && _this2.submission) _this2.state.mediaType = 'submissionVideo';
    }

    return _this2;
  }

  babelHelpers.createClass(CampaignSubmissionBody, [{
    key: "canSubmit",
    value: function canSubmit() {
      if (this.state.submissionComplete || this.state.submitting) return false;
      if (!this.state.title) return false;

      if (!this.submission) {
        switch (this.state.mediaType) {
          case '_any':
            return false;

          case 'submissionLink':
            if (!this.state.videoLink) return false;
            if (!this.getTypeAndId(this.state.videoLink)) return false;
            break;

          default:
            if (!this.state.content && !this.state.fileUploadCallback) return false; // if (!this.state.fileUploadCallback) return false;

            break;
        }
      }

      return true;
    }
  }, {
    key: "fieldUpdated",
    value: function fieldUpdated(event) {
      var x = babelHelpers.defineProperty({}, event.target.name, event.target.value);
      var nm = event.target.name;
      this.setState(function (st) {
        if (nm == 'mediaType' && st.mediaType != x.mediaType) {
          x.generation = st.generation + 1;
        }

        return x;
      });
      /*
      if (prevState.mediaType != this.state.mediaType) {
      	this.setState(st => ({ generation: st.generation + 1 }));
      }
      this.setState({ [event.target.name]: event.target.value })
      */
    }
  }, {
    key: "checkboxToggled",
    value: function checkboxToggled(event) {
      this.setState(babelHelpers.defineProperty({}, event.target.name, event.target.checked));
    }
  }, {
    key: "formSubmitted",
    value: function formSubmitted(event) {
      var _this3 = this;

      event.preventDefault();
      if (this.state.submitting) return;
      var state = {};
      this.doThumbnailUpload().then(function (value) {
        return Object.assign(state, {
          thumbnail: value
        });
      }).then(function () {
        return _this3.doFileUpload();
      }).then(function (value) {
        return Object.assign(state, value);
      }).then(function (state) {
        return Object.assign(state, {
          submission: _this3.submission ? _this3.submission.id : null,
          campaign: _this3.campaign.id,
          title: _this3.state.title,
          tags: _this3.state.tags,
          description: _this3.state.description,
          explicitContent: _this3.state.explicitContent
        });
      }).then(function (state) {
        return _this3.asModerator ? Object.assign(state, {
          hideFromSite: _this3.state.hideFromSite
        }) : state;
      }).then(function (state) {
        return (0, _fetch.default)('data/campaign/submit', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(state)
        });
      }).then(function (result) {
        return result.status == 204 ? {
          success: true
        } : result.json();
      }).then(function (result) {
        return _this3.submitted(result);
      }).catch(function (err) {
        return _this3.submitted({
          success: false,
          error: err && 'message' in err ? err.message : 'Internal error, please try again later.'
        });
      });
    }
  }, {
    key: "doThumbnailUpload",
    value: function doThumbnailUpload() {
      var _this4 = this;

      var F = this.state.imageUploadCallback || function () {
        return _promisePolyfill.default.resolve(_this4.state.listImage);
      };

      return F();
    }
  }, {
    key: "doFileUpload",
    value: function doFileUpload() {
      var _this5 = this;

      if (this.submission) {
        return _promisePolyfill.default.resolve(null);
      }

      if (this.state.mediaType == 'submissionLink') return _promisePolyfill.default.resolve({
        mediaType: 'submissionVideo',
        videoLink: this.state.videoLink
      });

      var F = this.state.fileUploadCallback || function () {
        return _promisePolyfill.default.resolve(_this5.state.content);
      };

      return F().then(function (value) {
        return {
          mediaType: _this5.state.mediaType,
          file: value
        };
      });
    }
  }, {
    key: "submitted",
    value: function submitted(result) {
      if (result.success) {
        this.setState({
          submitting: false,
          submissionComplete: true,
          imageUploadCallback: null,
          fileUploadCallback: null
        });
      } else {
        this.setState({
          submitting: false,
          error: result.error
        });
      }
    }
  }, {
    key: "internalGotCommentField",
    value: function internalGotCommentField(node) {
      this.commentField = node;
    }
  }, {
    key: "gotFakeElement",
    value: function gotFakeElement(node) {
      this.fakeElement = node;
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (prevState.description != this.state.description && this.fakeElement && this.commentField) {
        this.updateSize();
      }

      if (this.submission && this.state.submissionComplete) {
        (0, _userProfile.userProfileUpdated)();
      }

      this.props.modal.element.querySelector('.modal-dialog').scrollTop = this.tempScrollPosition;
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this6 = this;

      this.updateSize();
      this.props.modal.element.querySelector('.modal-dialog').addEventListener('scroll', function () {
        _this6.tempScrollPosition = _this6.props.modal.element.querySelector('.modal-dialog').scrollTop;
      });
      this.componentIsMounted = true;
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.componentIsMounted = false;
    }
  }, {
    key: "updateSize",
    value: function updateSize() {
      var _this7 = this;

      if (this.fakeElement && this.commentField) {
        var v = this.state.description || "";
        var nl = this.fakeElement.childNodes;
        var cStyle = window.getComputedStyle(this.commentField);
        ['boxSizing', 'paddingTop', 'paddingBottom', 'paddingLeft', 'paddingRight', 'borderTopWidth', 'borderLeftWidth', 'borderRightWidth', 'borderBottomWidth', 'whiteSpace', 'fontFamily', 'fontStyle', 'fontSize', 'fontWeight', 'lineHeight'].forEach(function (p) {
          return _this7.fakeElement.style[p] = cStyle[p];
        });
        this.fakeElement.style.position = 'fixed';
        this.fakeElement.style.right = '150%';
        v = v.split('\n');

        for (var i = 0; i < v.length; i++) {
          if (!nl[i]) this.fakeElement.appendChild(document.createElement('div'));
          nl[i].textContent = v[i] || '\xa0';
        }

        while (nl.length > v.length) {
          this.fakeElement.removeChild(nl[nl.length - 1]);
        }

        var w,
            tgtH,
            rowCount = this.commentFieldMinLines;

        do {
          w = this.commentField.clientWidth;
          console.log(this.fakeElement.style.width = this.fakeElement.style.boxSizing == 'border-box' ? "".concat(w, "px") : "calc(".concat(w, "px - ").concat(cStyle.paddingLeft, " - ").concat(cStyle.paddingRight, " - ").concat(cStyle.borderLeftWidth, " - ").concat(cStyle.borderRightWidth, ")"));
          tgtH = this.fakeElement.offsetHeight;
          console.log(this.commentField.style.height = this.fakeElement.style.boxSizing == 'border-box' ? "calc(".concat(tgtH, "px + 1px)") : "calc(".concat(tgtH, "px - ").concat(cStyle.paddingTop, " - ").concat(cStyle.paddingBottom, " - ").concat(cStyle.borderTopWidth, " - ").concat(cStyle.borderBottomWidth, " + 1px)"));
        } while (w != this.commentField.clientWidth);
      }
    }
  }, {
    key: "tagToggled",
    value: function tagToggled(event) {
      var tagValue = event.target.value;
      var isAdded = event.target.checked;
      this.setState(function (state) {
        var T = state.tags.filter(function (tag) {
          return tag != tagValue;
        });
        if (isAdded) T.push(tagValue);
        return {
          tags: T
        };
      });
    }
  }, {
    key: "setFileUploadCallback",
    value: function setFileUploadCallback(callback) {
      this.setState({
        fileUploadCallback: callback
      });
    }
  }, {
    key: "setImageUploadCallback",
    value: function setImageUploadCallback(callback) {
      this.setState({
        imageUploadCallback: callback
      });
    }
  }, {
    key: "deleteSubmission",
    value: function deleteSubmission() {
      this.setState({
        deletingSubmission: true
      });
    }
  }, {
    key: "cancelDelete",
    value: function cancelDelete() {
      this.setState({
        deletingSubmission: false
      });
    }
  }, {
    key: "doDeleteSubmission",
    value: function doDeleteSubmission() {
      var _this8 = this;

      (0, _fetch.default)('data/campaign/delete', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          submissionId: this.submission.id
        })
      }).then(function (data) {
        return data.ok ? {
          ok: true
        } : data.json();
      }).then(function () {
        (0, _noty.showNotificationText)('Your submission has been deleted.');

        _this8.modal.hide();

        _SiteLayout.default.current.navigate(_this8.campaign.link || document.querySelector('base').href);
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this9 = this;

      if (this.state.submissionComplete) {
        if (this.submission) {
          return _react.default.createElement("div", {
            className: "campaign-submission-complete"
          }, _react.default.createElement("div", {
            className: "success-header"
          }, _react.default.createElement("span", {
            className: "material-icons",
            "data-icon": "check"
          })), _react.default.createElement("h1", null, "Thank you!"), this.asOwner ? _react.default.createElement("p", null, "Your work has been updated.") : _react.default.createElement("p", null, "This submission has been updated."), _react.default.createElement("div", {
            className: "close-button"
          }, _react.default.createElement("button", {
            "data-dismiss": "modal",
            className: "btn btn-primary"
          }, "Close")));
        } // If there is no submission (this is new), it's always asOwner.


        return _react.default.createElement("div", {
          className: "campaign-submission-complete"
        }, _react.default.createElement("div", {
          className: "success-header"
        }, _react.default.createElement("span", {
          className: "material-icons",
          "data-icon": "check"
        })), _react.default.createElement("h1", null, "Thank you!"), _react.default.createElement("p", null, "Your work has been submitted. Please allow up to ", this.state.mediaType == 'submissionLink' || this.state.mediaType == 'submissionDocument' ? 10 : 20, " minutes for processing. You will receive a notification including a link to your submission page when processing has completed."), _react.default.createElement("div", {
          className: "close-button"
        }, _react.default.createElement("button", {
          "data-dismiss": "modal",
          className: "btn btn-primary"
        }, "Close")));
      }

      return _react.default.createElement("div", {
        className: "campaign-submission"
      }, _react.default.createElement("div", {
        className: "submission-info"
      }, this.submission ? _react.default.createElement("h3", null, "Updating", this.asOwner ? ' your ' : ' ', "submission") : _react.default.createElement("h3", null, "Submitting your work for"), this.submission ? _react.default.createElement("h1", null, this.submission.title) : _react.default.createElement("h1", null, this.campaign.title), this.campaign.submissionGuideline && _react.default.createElement("section", null, _react.default.createElement("header", null, _react.default.createElement("h3", null, "Submission Guidelines")), _react.default.createElement("div", {
        dangerouslySetInnerHTML: {
          __html: this.campaign.submissionGuideline
        }
      })), this.campaign.technicalDetails && _react.default.createElement("section", null, _react.default.createElement("header", null, _react.default.createElement("h3", null, "Technical Details")), _react.default.createElement("div", {
        dangerouslySetInnerHTML: {
          __html: this.campaign.technicalDetails
        }
      })), this.submission && _react.default.createElement("section", null, _react.default.createElement("header", null, _react.default.createElement("h3", null, "Instructions")), _react.default.createElement("div", null, _react.default.createElement("p", null, "Use this form to update the information about", this.asOwner ? ' your ' : ' this ', "work submission.", this.asOwner && "\n\t\t\t\t\t\t\t\t\tIf you would like to submit a new or updated version of your work file, please visit\n\t\t\t\t\t\t\t\t", this.asOwner && _react.default.createElement("a", {
        href: this.campaign.link
      }, this.campaign.title), this.asOwner && '.'))), this.submission && _react.default.createElement("section", {
        className: "delete-block"
      }, _react.default.createElement("div", null, "If you'd like to remove", this.asOwner ? " your " : " this ", " work submission from our site, use the link below. Note that all discussions and feedback attached to", this.asOwner ? " your " : " this ", "work will also be deleted. This change is permanent and non-reversible.", _react.default.createElement("br", null), _react.default.createElement("a", {
        href: "javascript:void(0)",
        onClick: this.deleteSubmission
      }, "Delete this submission")))), _react.default.createElement("div", {
        className: "form-body"
      }, !(this.submission && this.state.deletingSubmission) ? _react.default.createElement("form", {
        method: "post",
        action: "data/campaign/submit",
        onSubmit: this.formSubmitted
      }, this.state.error && _react.default.createElement("div", {
        className: "alert alert-danger"
      }, this.state.error), _react.default.createElement("div", {
        className: "form-group"
      }, _react.default.createElement("label", null, "Title, or working title, of", this.asOwner ? " your " : ' ', "work ", _react.default.createElement("span", null, "*")), _react.default.createElement("input", {
        className: "form-control",
        name: "title",
        value: this.state.title,
        onChange: this.fieldUpdated,
        disabled: this.state.submitting
      })), !!this.asModerator && _react.default.createElement("div", {
        className: "checkbox"
      }, _react.default.createElement("label", null, _react.default.createElement("input", {
        type: "checkbox",
        name: "hideFromSite",
        value: "1",
        disabled: this.state.submitting,
        checked: this.state.hideFromSite,
        onChange: this.checkboxToggled
      }), "Hide this content from the site. It will only be visible to the original submitter and to moderators.")), !this.submission || this.submission.description.editable ? _react.default.createElement("div", {
        className: "form-group"
      }, _react.default.createElement("label", null, "Please enter at least a paragraph or two describing", this.asOwner ? " your " : " this ", "work and any credits that you would like to share."), _react.default.createElement("textarea", {
        ref: this.internalGotCommentField,
        className: "form-control",
        name: "description",
        rows: "3",
        value: this.state.description,
        onChange: this.fieldUpdated,
        disabled: this.state.submitting
      }), _react.default.createElement("div", {
        className: _classList.default.join('fake-textarea', this.state.comment ? '' : 'fake-textarea-placeholder'),
        ref: this.gotFakeElement
      })) : _react.default.createElement("div", {
        className: "form-group"
      }, _react.default.createElement("label", null, "Please enter at least a paragraph or two describing", this.asOwner ? " your " : " this ", "work and any credits that you would like to share."), _react.default.createElement("div", {
        className: "user-description",
        dangerouslySetInnerHTML: {
          __html: this.submission.description.markup
        }
      })), !!this.campaign.customTags.length && _react.default.createElement("div", {
        className: "form-group category-button-list"
      }, _react.default.createElement("label", null, "Select the categories that describe", this.asOwner ? " your " : " this ", "work"), _react.default.createElement("div", {
        className: "buttons"
      }, this.campaign.customTags.map(function (tag) {
        return _react.default.createElement("div", {
          key: tag.id,
          className: "campaign-tag"
        }, _react.default.createElement("label", null, _react.default.createElement("input", {
          type: "checkbox",
          name: "tags[]",
          value: tag.id,
          checked: _this9.state.tags.indexOf(tag.id) != -1,
          onChange: _this9.tagToggled,
          disabled: _this9.state.submitting
        }), _react.default.createElement("span", null, tag.tag)));
      }))), !this.submission && this.campaign.mediaType == '_any' && _react.default.createElement("div", {
        className: "form-group type-buttons"
      }, _react.default.createElement("label", null, "Your work ", _react.default.createElement("span", null, "*")), _react.default.createElement("div", {
        className: "buttons"
      }, _react.default.createElement("div", {
        className: "type-button"
      }, _react.default.createElement("label", null, _react.default.createElement("input", {
        type: "checkbox",
        disabled: this.state.submitting,
        name: "mediaType",
        value: "submissionLink",
        checked: this.state.mediaType == 'submissionLink',
        onChange: this.fieldUpdated
      }), _react.default.createElement("span", null, "Link to Video"))), _react.default.createElement("div", {
        className: "type-button"
      }, _react.default.createElement("label", null, _react.default.createElement("input", {
        type: "checkbox",
        disabled: this.state.submitting,
        name: "mediaType",
        value: "submissionVideo",
        checked: this.state.mediaType == 'submissionVideo',
        onChange: this.fieldUpdated
      }), _react.default.createElement("span", null, "Upload Video"))), _react.default.createElement("div", {
        className: "type-button"
      }, _react.default.createElement("label", null, _react.default.createElement("input", {
        type: "checkbox",
        disabled: this.state.submitting,
        name: "mediaType",
        value: "submissionAudio",
        checked: this.state.mediaType == 'submissionAudio',
        onChange: this.fieldUpdated
      }), _react.default.createElement("span", null, "Upload Audio"))), _react.default.createElement("div", {
        className: "type-button"
      }, _react.default.createElement("label", null, _react.default.createElement("input", {
        type: "checkbox",
        disabled: this.state.submitting,
        name: "mediaType",
        value: "submissionDocument",
        checked: this.state.mediaType == 'submissionDocument',
        onChange: this.fieldUpdated
      }), _react.default.createElement("span", null, "Upload PDF"))))), !this.submission && this.campaign.mediaType == 'submissionVideo' && _react.default.createElement("div", {
        className: "form-group type-buttons"
      }, _react.default.createElement("label", null, "Your video file ", _react.default.createElement("span", null, "*")), _react.default.createElement("div", {
        className: "buttons"
      }, _react.default.createElement("div", {
        className: "type-button"
      }, _react.default.createElement("label", null, _react.default.createElement("input", {
        type: "checkbox",
        disabled: this.state.submitting,
        name: "mediaType",
        value: "submissionLink",
        checked: this.state.mediaType == 'submissionLink',
        onChange: this.fieldUpdated
      }), _react.default.createElement("span", null, "Link to Video"))), _react.default.createElement("div", {
        className: "type-button"
      }, _react.default.createElement("label", null, _react.default.createElement("input", {
        type: "checkbox",
        disabled: this.state.submitting,
        name: "mediaType",
        value: "submissionVideo",
        checked: this.state.mediaType == 'submissionVideo',
        onChange: this.fieldUpdated
      }), _react.default.createElement("span", null, "Upload Video"))))), !this.submission && (this.state.mediaType == 'submissionVideo' || this.state.mediaType == 'submissionAudio' || this.state.mediaType == 'submissionDocument' ? _react.default.createElement("div", {
        className: "form-group"
      }, _react.default.createElement("label", null, "Select your ", this.state.mediaType == 'submissionVideo' ? 'Video' : this.state.mediaType == 'submissionAudio' ? 'Audio File' : 'PDF', " ", _react.default.createElement("span", null, "*")), _react.default.createElement("div", null, _react.default.createElement(_S3FileUploadControl.S3FileUploadControl, {
        disabled: this.state.submitting,
        initialValue: this.state.content,
        setUploadCallback: this.setFileUploadCallback,
        generation: this.state.generation,
        accept: this.acceptTypes[this.state.mediaType],
        buttonContent: "Select",
        junk: "".concat(this.acceptTypes[this.campaign.mediaType].label),
        buttonClass: "btn upload-btn upload-".concat(this.state.mediaType, "-btn submission-upload-btn"),
        selectedButtonClass: "btn selected-upload-btn upload-".concat(this.state.mediaType, "-btn submission-upload-btn")
      })), this.campaign.technicalDetails && _react.default.createElement("footer", null, _react.default.createElement("p", null, "Note: View the 'Technical Details' for more information regarding your work file."))) : this.state.mediaType == 'submissionLink' ? _react.default.createElement("div", {
        className: "form-group"
      }, _react.default.createElement("label", null, "Video file link ", _react.default.createElement("span", null, "*")), _react.default.createElement("input", {
        className: "form-control",
        name: "videoLink",
        value: this.state.videoLink,
        onChange: this.fieldUpdated,
        disabled: this.state.submitting
      }), _react.default.createElement("footer", null, _react.default.createElement("p", null, "Note: We currently only support links to videos hosted on YouTube or Vimeo. Please make sure your video's permissions are set to 'Public'."))) : _react.default.createElement("div", {
        className: "form-group disabled"
      }, _react.default.createElement("label", null, "Select your file ", _react.default.createElement("span", null, "*")), _react.default.createElement("div", null, _react.default.createElement("button", {
        className: "btn upload-btn submission-upload-btn disabled",
        disabled: true
      }, "Select")), this.campaign.technicalDetails && _react.default.createElement("footer", null, _react.default.createElement("p", null, "Note: View the 'Technical Details' for more information regarding your work file.")))), _react.default.createElement("div", {
        className: "form-group"
      }, _react.default.createElement("label", null, "Select a thumbnail image"), _react.default.createElement("div", null, _react.default.createElement(_S3FileUploadControl.S3FileUploadControl, {
        initialValue: this.state.listImage,
        setUploadCallback: this.setImageUploadCallback,
        generation: this.state.thumbGeneration,
        accept: this.acceptTypes.image,
        disabled: this.state.submitting,
        buttonContent: "Select",
        buttonClass: "btn upload-btn submission-upload-btn upload-image-btn",
        selectedButtonClass: "btn selected-upload-btn submission-upload-btn upload-image-btn"
      })), _react.default.createElement("footer", null, _react.default.createElement("p", null, "The thumbnail image will be displayed when your work is included in lists or presented in a media player. Image size recommendations: Minimum 640 pixels wide by 360 pixels high, PNG or JPG file type."))), _react.default.createElement("div", {
        className: "checkbox"
      }, _react.default.createElement("label", null, _react.default.createElement("input", {
        type: "checkbox",
        name: "explicitContent",
        value: "1",
        disabled: this.state.submitting,
        checked: this.state.explicitContent,
        onChange: this.checkboxToggled
      }), this.asOwner ? "My " : "This ", "work contains explicit content (", _react.default.createElement("a", {
        href: "javascript:void(0)",
        onClick: function onClick() {
          return _text.ExplicitContentStatementModal.show();
        },
        title: "View explicit content policy"
      }, "?"), ")")), this.asOwner && _react.default.createElement("p", null, "By submitting your work, you verify that you have read and agree to our ", _react.default.createElement("a", {
        href: "javascript:void(0)",
        onClick: function onClick() {
          return _text.UserSubmissionGuidelinesModal.show();
        },
        title: "View user submission policy"
      }, "User Submission Policy"), "."), _react.default.createElement("div", {
        className: "form-submit"
      }, _react.default.createElement("button", {
        className: "btn btn-primary",
        type: "submit",
        disabled: !this.canSubmit()
      }, "Submit")), this.submission && _react.default.createElement("section", {
        className: "delete-block"
      }, _react.default.createElement("div", null, "If you'd like to remove", this.asOwner ? " your " : " this ", "work submission from our site, use the link below. Note that all discussions and feedback attached to", this.asOwner ? " your " : " this ", "work will also be deleted. This change is permanent and non-reversible.", _react.default.createElement("br", null), _react.default.createElement("a", {
        href: "javascript:void(0)",
        onClick: this.deleteSubmission
      }, "Delete this submission")))) : _react.default.createElement("form", {
        method: "post",
        action: "javascript:void(0)",
        onSubmit: function onSubmit() {}
      }, _react.default.createElement("h2", null, "Are you sure you want to delete", this.asOwner ? " your " : " this ", "submission?"), _react.default.createElement("p", null, "This change is permanent and non-reversible."), _react.default.createElement("div", {
        className: "form-submit"
      }, _react.default.createElement("button", {
        className: "btn btn-danger",
        onClick: this.doDeleteSubmission,
        type: "button"
      }, "Delete", this.asOwner ? " Your " : " This ", "Submission")), _react.default.createElement("div", {
        className: "form-submit"
      }, _react.default.createElement("button", {
        className: "btn btn-link",
        onClick: this.cancelDelete,
        type: "button"
      }, "Cancel")))));
    }
  }]);
  return CampaignSubmissionBody;
}(_react.Component), _temp), (_descriptor = babelHelpers.applyDecoratedDescriptor(_class.prototype, "campaign", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "submission", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "modal", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "asOwner", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "asModerator", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), babelHelpers.applyDecoratedDescriptor(_class.prototype, "fieldUpdated", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "fieldUpdated"), _class.prototype), babelHelpers.applyDecoratedDescriptor(_class.prototype, "checkboxToggled", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "checkboxToggled"), _class.prototype), babelHelpers.applyDecoratedDescriptor(_class.prototype, "formSubmitted", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "formSubmitted"), _class.prototype), babelHelpers.applyDecoratedDescriptor(_class.prototype, "internalGotCommentField", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "internalGotCommentField"), _class.prototype), babelHelpers.applyDecoratedDescriptor(_class.prototype, "gotFakeElement", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "gotFakeElement"), _class.prototype), babelHelpers.applyDecoratedDescriptor(_class.prototype, "tagToggled", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "tagToggled"), _class.prototype), babelHelpers.applyDecoratedDescriptor(_class.prototype, "setFileUploadCallback", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "setFileUploadCallback"), _class.prototype), babelHelpers.applyDecoratedDescriptor(_class.prototype, "setImageUploadCallback", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "setImageUploadCallback"), _class.prototype), babelHelpers.applyDecoratedDescriptor(_class.prototype, "deleteSubmission", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "deleteSubmission"), _class.prototype), babelHelpers.applyDecoratedDescriptor(_class.prototype, "cancelDelete", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "cancelDelete"), _class.prototype), babelHelpers.applyDecoratedDescriptor(_class.prototype, "doDeleteSubmission", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "doDeleteSubmission"), _class.prototype)), _class);
exports.CampaignSubmissionBody = CampaignSubmissionBody;